// extracted by mini-css-extract-plugin
module.exports =  {"root":"dWBKcxJGGbQzKbO9vU5m"};